// This is the store, it's used to store data which is accessed from multiple components
// data cannot be mutated directly, instead is committed to the store using commit actions
// The store is broken up into modules


import Vue from 'vue'
import Vuex from 'vuex'

// import VuexPersistence from 'vuex-persist'

import reference from './modules/reference'
import auth from './modules/auth'
import cart from './modules/cart'
import member from './modules/member'
import favourites from './modules/favourites'
import misc from "./modules/misc"

Vue.use(Vuex)


export default new Vuex.Store({
	modules: {
		reference, //handles categories/subcategories ID's and names
		auth, // handles login and log out
		cart, //handles adding, removing and updating cart items
		member, //handles logged in member details
		favourites, //handles favourites
		misc,
	},
	// plugins: [new VuexPersistence().plugin]
})
